import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=d4ba89ee"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=d4ba89ee&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4ba89ee')) {
      api.createRecord('d4ba89ee', component.options)
    } else {
      api.reload('d4ba89ee', component.options)
    }
    module.hot.accept("./BasicLayout.vue?vue&type=template&id=d4ba89ee", function () {
      api.rerender('d4ba89ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/BasicLayout.vue"
export default component.exports